export var legislation_jurisdiction = `
    The present usage conditions and privacy policy for the platform will be governed and interpreted in accordance with Spanish legislation. <br/><br/>
    Any disputes or controversies that could arise between FUNDACIÓ EURECAT and the user shall be handled in Spanish courts and tribunals. <br/><br/>
`;